import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import type { ApiKey } from "@/types/api";

export const useApi = () => {
	const apiKeys = useQuery({
		queryKey: ["apiKeys"],
		queryFn: async () => await api.get<ApiKey[] | []>("/apiKeys"),
		select: (data) => data,
	});
	const createApiKeyMutation = useMutation({
		mutationFn: (apiKey: { project: string } & Partial<Omit<ApiKey, "id">>) =>
			api.post<ApiKey>("/apiKey", apiKey),
	});

	const deleteApiKeyMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/apiKey/${id}`),
	});

	return {
		apiKey: apiKeys.data,
		createApiAsync: createApiKeyMutation.mutateAsync,
		deleteApiKeyAsync: deleteApiKeyMutation.mutateAsync,
		isLoading: apiKeys.isLoading,
		error:
			createApiKeyMutation.error || deleteApiKeyMutation.error || apiKeys.error,
	};
};
